<template>
	<div class="cnt-settings" id="content">
		<div class="row">
			<div class="col-sm-3">
				<span>Data</span>
				<input type="date" v-model="data.data" class="form-control" />
			</div>
			<div class="col-sm-3">
				<span>Data de renovação</span>
				<input
					type="date"
					v-model="data.renovacao"
					class="form-control"
				/>
			</div>
			<div class="col-sm-3">
				<span>Região</span>
				<select
					class="form-control"
					v-model="data.regiao"
					:disabled="data.status == 'CS'"
				>
					<option value="">Escolher</option>
					<option
						v-for="(reg, index) in assets.regioes"
						:key="index"
						:value="reg.regiao"
					>
						{{ reg.regiao }} - {{ reg.localidade }}
					</option>
				</select>
			</div>
			<div class="col-sm-3">
				<span>Imprimir proposta</span>
				<!-- <button @click="download()"><i class="fa-solid fa-print"></i></button> -->
				<print-btn :data="dIn" loader="proposta" no-title />
				<!-- <div class="input-group">
					<select class="form-control" v-model='impProp'>
						<option value="0">Escolher proposta</option>
						<div v-if='docs_groups(temp.modalidade) == "proposta"'>
							<option
							v-for='temp in assets.tmp' :value="temp.cod" :key="temp.cod">
							{{temp.titulo}}
						</option>
						</div>

					</select>
					<span class="input-group-btn">
						<router-link
						data-dismiss='modal'
						:to="'/imprimir/proposta:'+ impProp + '/' + data.cod"
						class="btn btn-info">
						<i class="fa fa-print"></i>
						</router-link>
					</span>
				</div> -->
			</div>
		</div>
		<br />
		<div class="well well-sm">
			<div class="row">
				<div class="col-sm-6 col-md-3">
					<span>Vendedor</span>
					<select class="form-control" v-model="data.cod_vendedor">
						<option value="">Escolher</option>
						<option
							v-for="(vend, index) in assets.vends"
							:key="index"
							:value="vend.cod"
						>
							{{ vend.vendedor }}
						</option>
					</select>
				</div>
				<div class="col-sm-6 col-md-4">
					<span>Gestor</span>
					<select class="form-control" v-model="data.cod_gestor">
						<option value="">Escolher</option>
						<option
							v-for="(gestor, index) in assets.gestores"
							:key="index"
							:value="gestor.cod"
						>
							{{ gestor.razao_social }}
						</option>
					</select>
				</div>

				<div class="col-sm-6 col-md-3">
					<span>Categoria</span>
					<select class="form-control" v-model="data.cod_categoria">
						<option value="">Escolher</option>
						<option
							v-for="(cat, index) in assets.cats"
							:key="index"
							:value="cat.cod"
						>
							{{ cat.titulo }} - {{ cat.reducao }}%
						</option>
					</select>
				</div>
				<div class="col-sm-6 col-md-2">
					<span>Tipo de proposta</span>
					<select class="form-control" v-model="data.cod_tipprop">
						<option value="">Escolher</option>
						<option
							v-for="(tp, index) in assets.tprop"
							:key="index"
							:value="tp.cod"
						>
							{{ tp.titulo }}
						</option>
					</select>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-12">
				<b>Faturamento</b>
				<div class="well well-sm">
					<div class="row">
						<div class="col-sm-4">
							<span>Forma de pagamento</span>
							<select
								class="form-control"
								v-model="data.forma_pagamento"
							>
								<option value="">Escolher</option>
								<option value="DINHEIRO">Dinheiro</option>
								<option value="BOLETO">Boleto</option>
								<option value="CHEQUE">Cheque</option>
								<option value="CATÃO DE CRÉDITO">
									Cartão de Crédito
								</option>
								<option value="CARTÃO DE DÉBITO">
									Cartão de Débito
								</option>
							</select>
						</div>
						<div class="col-xs-4">
							<span>Dia pagamento</span>
							<input
								type="text"
								v-model="data.dia_pagamento"
								class="form-control"
							/>
							<!-- <select
								v-model="data.dia_pagamento"
								class="form-control"
							>
								<option value="0">Escolher</option>
								<option value="8">08</option>
								<option value="10">10</option>
								<option value="15">15</option>
								<option value="20">20</option>
								<option value="25">25</option>
							</select> -->
						</div>
						<div class="col-xs-4">
							<span>Qnt. Parcelas</span>
							<select
								v-model="data.parcelas"
								class="form-control"
							>
								<option value="0">Escolher</option>
								<option
									v-for="(n, index) in 12"
									:key="index"
									:value="n"
								>
									{{ n }}
								</option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-12">
				<b>Observação</b>
				<textarea
					rows="5"
					class="form-control"
					v-model="data.obs"
				></textarea>
			</div>
		</div>
	</div>
</template>
<script>
	import docsType from 'js/docsType';
	import printBtn from 'app/printBtn';
	import jspdf from 'jspdf';

	export default {
		name: 'mdPropLinha1',
		props: ['dIn', 'assets'],
		components: { printBtn },
		data() {
			return {
				impProp: 0,
			};
		},
		computed: {
			data() {
				return this.dIn;
			},
		},
		methods: {
			docs_groups(id) {
				let findModDocs = docsType.find((i) => i.id == id);
				return findModDocs !== undefined ? findModDocs.grupo : '';
			},
			toggleRegiao() {
				// this.assets.clientes.forEach(cli => {
				//       if(cli.cnpj == this.data.cnpj && cli.regiao != '')
				//             this.data.regiao = cli.regiao
				// })
			},

			// download(){
			// 	// console.log(this.$refs.content)
			// 	const doc = new jspdf()
			// 	const html = window.document.getElementsById("content")[0]
			// 	console.log(html)

			// 	doc.fromHTML(html, 15, 15, {width: 150})
			// 	doc.save("output.pdf")
			// }
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/proposals/components/components/settings.vue